import request from '@/blocks/request';

export function getBrandList(params) {
  return request({
    useLoading: true,
    baseURL: process.env.VUE_APP_PANGKU_API,
    url: `/v1/comm/carbrands`,
    params: {
      type: 'list',
      ...params,
    },
  });
}

export function getSeriesList(params) {
  return request({
    useLoading: true,
    baseURL: process.env.VUE_APP_PANGKU_API,
    url: `/car/firms`,
    params: {
      type: 'list',
      ...params,
    },
  });
}
